export const columns=[    
       { 
        field: "name", 
        header: "Role",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"name")}  className="">          
                <p className="w-[6rem] cursor-pointer text-blue-600 hover:text-blue-800" >
                {row?.name}
                </p>
              </div>
            </>
          ),
       },
       { 
        field: "role_id", 
        header: "Role Id",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"role_id")}  className="">          
                <p className="w-[6rem]">
                 {row?.role_id}
                </p>
              </div>
            </>
          ), 
       },
       { 
        field: "active", 
        header: "Active",
        accessor: (row,handleCellClick) => (
            <>
              <div  onClick={()=>handleCellClick(row,"active")}  className="">          
                <p className="w-[6rem]">
                 {JSON.stringify(row?.active)||""}               
                </p>
              </div>
            </>
          ), 
       },
]

export const searchBy = {
  filterType: "Sort By",
  inputName: "search_by",
  options: [
    {
      name: "Descending ",
      code: "desc",
    },
    {
      name: "Ascending",
      code: "asc",
    },
  ],
};